/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import React from 'react';
import { Box, Card, IconButton, Typography } from '@mui/material';
import { pxToRem } from '@vamstar/fox-frontend-common';
import Delete from '@mui/icons-material/Delete';

interface IElasticDslInformationProps {
  elasticDsl: string | undefined;
  onRemoveDsl: () => void;
}

export const ElasticDslInformation = (props: IElasticDslInformationProps) => {
  const { elasticDsl, onRemoveDsl } = props;

  if (elasticDsl) {
    return (
      <Card sx={{ padding: pxToRem('16') }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" flexDirection="column">
            <Box display="flex" columnGap={1}>
              <Typography>Query -</Typography>
              <Typography fontFamily="monospace">{elasticDsl}</Typography>
            </Box>
          </Box>
          <Box display="flex">
            <IconButton
              onClick={() => {
                onRemoveDsl();
              }}
            >
              <Delete />
            </IconButton>
          </Box>
        </Box>
      </Card>
    );
  }

  return <></>;
};
